import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import { ROLE_LABEL, type Account } from '@/auth/account';
import { PageHeader } from '@/components/PageHeader';
import { Card } from '@/components/ui/Card';

interface UserEntry extends Account {
  createdAt: string;
  lastLoginAt: string;
}

const dateTime = new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium', timeStyle: 'short' });

/** Who has access (admins only). Roles are managed in authentik via the invest-* groups. */
export function Users() {
  const users = useQuery({ queryKey: ['users'], queryFn: () => api.get<UserEntry[]>('/users') });
  return (
    <>
      <PageHeader title="Benutzer" subtitle="Wer Zugriff hat. Rollen vergibst du in authentik über die Gruppen invest-admin, invest-editor und invest-viewer." />
      <Card>
        {users.isPending ? (
          <p className="px-5 py-6 text-sm text-[var(--ink-3)]">Lädt …</p>
        ) : users.error ? (
          <p role="alert" className="px-5 py-6 text-sm text-[var(--ink-2)]">{(users.error as Error).message}</p>
        ) : (
          <ul className="divide-y divide-[var(--border)]">
            {users.data!.map((u) => (
              <li key={u.id} className="flex flex-wrap items-center justify-between gap-3 px-5 py-3">
                <div className="min-w-0">
                  <p className="text-sm font-medium text-[var(--ink)]">{u.name}</p>
                  <p className="truncate text-xs text-[var(--ink-3)]">{u.email ?? '–'}</p>
                </div>
                <div className="flex items-center gap-3 text-xs text-[var(--ink-3)]">
                  <span>zuletzt {dateTime.format(new Date(u.lastLoginAt))}</span>
                  <span className="rounded-full bg-[var(--surface-2)] px-2 py-0.5 font-medium text-[var(--ink-2)]">{ROLE_LABEL[u.role]}</span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </>
  );
}
